import { PhoneArrowDownLeftIcon, PhoneArrowUpRightIcon } from '@heroicons/react/24/outline';
import type { EntryDirection } from '../../../../services/communications';

interface DirectionToggleProps {
    value: EntryDirection;
    onChange: (value: EntryDirection) => void;
}

// Segmented Incoming/Outgoing control, shared by every channel except
// 'note' (direction is required unless channel === 'note' - see the wire
// contract; callers simply don't render this for a note entry).
export function DirectionToggle({ value, onChange }: DirectionToggleProps) {
    return (
        <div className="flex items-center gap-0.5 bg-gray-100 rounded-md p-0.5 h-10 min-w-[240px]">
            <button
                type="button"
                onClick={() => onChange('incoming')}
                className={`flex-1 h-full rounded text-[13px] font-semibold flex items-center justify-center gap-1.5 transition-colors ${
                    value === 'incoming'
                        ? 'bg-white text-[#2C6F67] shadow-sm'
                        : 'text-gray-500 font-medium'
                }`}
            >
                <PhoneArrowDownLeftIcon className="h-3.5 w-3.5" />
                Incoming
            </button>
            <button
                type="button"
                onClick={() => onChange('outgoing')}
                className={`flex-1 h-full rounded text-[13px] font-semibold flex items-center justify-center gap-1.5 transition-colors ${
                    value === 'outgoing'
                        ? 'bg-white text-gray-900 shadow-sm'
                        : 'text-gray-500 font-medium'
                }`}
            >
                <PhoneArrowUpRightIcon className="h-3.5 w-3.5" />
                Outgoing
            </button>
        </div>
    );
}
